import React from 'react';

import { Heading, Text } from '@auspost/postmaster-react';

import ErrorIcon from 'assets/maintenance.svg';

import styles from './ServiceUnavailable.module.scss';

type MaintenancePageProps = {
  description?: string | null;
};

const MaintenancePage: React.FC<MaintenancePageProps> = ({ description }) => {
  const bodyText = description;

  return (
    <div className={styles.container} data-testid='maintenance-page'>
      <div className={styles.maintenanceIconWrapper}>
        <ErrorIcon />
      </div>
      <Heading level='h3' isBold data-testid='header' className={styles.header}>
        Tracking is down for maintenance
      </Heading>

      <Text variant='body' className={styles.text} data-testid='maintenance-body-text'>
        {bodyText}
      </Text>
    </div>
  );
};

export default MaintenancePage;
